// extracted by mini-css-extract-plugin
module.exports = {"footer":"SidebarPopupFooter__footer__8xh-i"};